// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3pv80","bigColWidth":"Table_bigColWidth__1hwk2","biggerColWidth":"Table_biggerColWidth__1oILa","row":"Table_row__3Eq4S","col":"Table_col__3s1wl"};